<script>
  // The app's manual, one screen at a time. A "?" affordance sits in the same
  // place on every screen; opening it slides in a panel with this screen's help:
  // what it is for (addressed to the signed-in role, imperative), how it works
  // (the mechanics), and — where relevant — a "for reference" block with the
  // Turtle/JSON the screen touches (passed as `children`, so it can carry live
  // Pod data via the Code component).
  //
  // `whatFor` / `howItWorks` / `reference` are app-authored HTML strings (see
  // lib/help.js), rendered with {@html} — trusted content that ships with the
  // app, never user input.
  import Drawer from './Drawer.svelte';

  let { title = 'About this screen', whatFor = '', howItWorks = '', reference = '', children = null } = $props();

  let open = $state(false);
  const hasReference = $derived(Boolean(reference) || Boolean(children));
</script>

<button
  class="help-toggle"
  aria-label="Open help for this screen"
  aria-expanded={open}
  onclick={() => (open = true)}
>?</button>

<Drawer {title} {open} onclose={() => (open = false)}>
  {#if whatFor}
    <section class="help-section">
      <h3 class="help-heading">What this screen is for</h3>
      <div class="help-prose">{@html whatFor}</div>
    </section>
  {/if}
  {#if howItWorks}
    <section class="help-section">
      <h3 class="help-heading">How it works</h3>
      <div class="help-prose">{@html howItWorks}</div>
    </section>
  {/if}
  {#if hasReference}
    <section class="help-section">
      <h3 class="help-heading">For reference</h3>
      {#if reference}<div class="help-prose">{@html reference}</div>{/if}
      {#if children}{@render children()}{/if}
    </section>
  {/if}
</Drawer>
